// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"deba0465","311":"2fa8d81b"}[chunkId] + ".chunk.css";
};